import { PROPS__image_bounds } from './PROPS__image_bounds';

/** Helper: Draws dark background and "No image" text within given bounds */
export function FN_CANVAS__draw_placeholder(ctx: CanvasRenderingContext2D, bounds: PROPS__image_bounds): void {
  ctx.fillStyle = '#171717';
  ctx.fillRect(bounds.x, bounds.y, bounds.w, bounds.h);

  ctx.fillStyle = '#a3a3a3';
  ctx.font = '400 26px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('No image', bounds.x + bounds.w * 0.5, bounds.y + bounds.h * 0.5);
}
